import { useTranslations } from 'next-intl';
import { useFormContext } from 'react-hook-form';

import { Button } from '@flipster/ui';

import { TpslTimeTriggerSchema } from '@web/features/modals/TimeTriggerTpslModal/bunja/validation';

import styles from '../../tpslModal.module.scss';

interface Props {
  isLoading: boolean;
  disabled: boolean;
}

const ConfirmButton = ({ isLoading, disabled }: Props) => {
  const transCommon = useTranslations('Common.r250401');
  const {
    formState: { isDirty, errors },
  } = useFormContext<TpslTimeTriggerSchema>();

  return (
    <footer className={styles.confirmWrapper}>
      <Button
        shape='primary'
        size='large'
        className={styles.confirm}
        isSubmit
        loading={isLoading}
        disabled={disabled || !isDirty || !!errors.triggerPriceRatio}
      >
        {transCommon('Confirm')}
      </Button>
    </footer>
  );
};

export default ConfirmButton;
